import { RefObject, useLayoutEffect } from "react"

interface Options {
    activate: boolean
    nodeRef: RefObject<HTMLElement>
    getStartNode(): HTMLElement | null
    idContainer?: string
}

export function useFitHeight({ activate, nodeRef, getStartNode, idContainer }: Options) {
    useLayoutEffect(() => {
        if (activate) {
            const startNode = getStartNode()
            const rect = startNode?.getBoundingClientRect()

            if (rect) {
                let maxHeight =
                    window.innerHeight -
                    Math.floor(rect.top) -
                    Math.floor(rect.height) -
                    24 /* отступ от нижней границы экрана */

                const node = nodeRef.current
                const containerEl = idContainer ? document.getElementById(idContainer) : undefined

                if (containerEl) {
                    maxHeight =
                        containerEl.offsetHeight -
                        (rect.top - containerEl.getBoundingClientRect().top) -
                        Math.floor(rect.height) -
                        24
                }
                node?.setAttribute("style", `max-height: ${Math.max(100, maxHeight)}px`)
            }
        }
    }, [activate])
}
